import Spinner from 'react-bootstrap/Spinner';
import React from 'react';

function ProcessSpinner() {

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ marginTop: '20px' }}>
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
}

export default ProcessSpinner;